"use strict";

exports.__esModule = true;
exports.DevicePropertyFields = DevicePropertyFields;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Fields for DevicePropertyElement.
 */
function DevicePropertyFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("DeviceProperty.propertyName.label", "Property")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _core.Classes.HTML_SELECT
    }, /*#__PURE__*/_react["default"].createElement("select", {
      value: element.props.propertyName,
      onChange: function onChange(e) {
        return elementEditor.setProp(path, "propertyName", e.target.value);
      }
    }, /*#__PURE__*/_react["default"].createElement("option", {
      value: "name"
    }, translate("DeviceProperty.propertyName.name.label", "Name")), /*#__PURE__*/_react["default"].createElement("option", {
      value: "uuid"
    }, translate("DeviceProperty.propertyName.uuid.label", "ID")))));
  });
}